import moment from "moment";

export class StartProjectResult {
    public id: number = 0;
    public assignedEmployeeId: number = 0;
    public assignedEmployeeFullName: string = '';
    public creationDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public projectName: string = '';
    public isDone: boolean = false;
    public isDeleted: boolean = false;
}
